import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { OperationalSystemInterface } from 'src/app/util/interfaces/operationalSystem';

@Injectable({
	providedIn: 'root',
})
export class OperationalSystemService {
	private getOperationalSystemsURL = environment.baseApiUrl + 'register/operationalSystem';
	private postOperationalSystemURL = environment.baseApiUrl + 'register/operationalSystem';
	private putOperationalSystemURL = environment.baseApiUrl + 'register/operationalSystem/{id}';
	private deleteOperationalSystemURL = environment.baseApiUrl + 'register/operationalSystem';

	constructor(
		private httpClient: HttpClient,
		private authLoginService: AuthLoginService
	) {}

	private getHeaders(): HttpHeaders {
		return new HttpHeaders({
			Authorization: 'Bearer ' + this.authLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
	}

	getOperationalSystems(): Observable<OperationalSystemInterface[]> {
		return this.httpClient.get<OperationalSystemInterface[]>(this.getOperationalSystemsURL, { headers: this.getHeaders() });
	}

	postOperationalSystem(data: OperationalSystemInterface): Observable<any> {
		const body = {
			operational_system: data.operational_system,
			type: data.type,
			ms_string: data.ms_string,
		};

		return this.httpClient.post(this.postOperationalSystemURL, body, { headers: this.getHeaders() });
	}

	putOperationalSystem(data: OperationalSystemInterface): Observable<any> {
		const putOperationalSystemURL = this.putOperationalSystemURL.replace('{id}', encodeURIComponent(data.id!.toString()));
		const body = {
			operational_system: data.operational_system,
			type: data.type,
			ms_string: data.ms_string,
		};

		return this.httpClient.put(putOperationalSystemURL, body, { headers: this.getHeaders() });
	}

	deleteOperationalSystems(ids: string[]): Observable<any> {
		return this.httpClient.delete(this.deleteOperationalSystemURL, {
			headers: this.getHeaders(),
			body: JSON.stringify({ ids }),
		});
	}
}
